import { defineStyleConfig } from '@chakra-ui/react';

import { textSizes } from './text';

export const linkTheme = defineStyleConfig({
  sizes: textSizes,
});
